import React, {FunctionComponent} from 'react';

import {FormAccessor, OnFormChangeCallback, route} from 'b302-frontend-library';
import { useNavigate } from 'react-router-dom';

import University from '../../../../networking/models/University';
import HanSearch from '../../../utils/HanSearch';
import HanButton from '../../../utils/HanButton';
import UniversityList from '../../partials/university/UniversityList';
import HanPagination from '../../../utils/HanPagination';
import {error} from '../../../../utils/Toast';
import {UniversityIndexResponse} from '../../../../networking/responses/University';
import {useUniversityDeleteMutation} from '../../../query/University/Mutation';

export interface UniversitySearchForm {
    searchQuery: string;
}

interface Props {
    universities: UniversityIndexResponse;

    onPageChange: (page: number) => void;
    form: FormAccessor<UniversitySearchForm>;
    onFormChange: OnFormChangeCallback<UniversitySearchForm>;
}

const UniversitiesContent: FunctionComponent<Props> = (props) => {
    const navigate = useNavigate();

    const universityDeleteMutation = useUniversityDeleteMutation()

    const newUniversity = () => {
        navigate(route('admin-new-university'));
    };

    const onUniversityClick = (university: University) => {
        navigate(route('admin-edit-university', university));
    };

    const onUniversityDeleteClick = (university: University) => {
        if(!window.confirm(`Delete university ${university.name}?`)) return;

        universityDeleteMutation.mutateAsync(university.id!)
            .catch((e: any) => error(e.message || `Error deleting university ${university.id}`));
    };

    return (
        <>
            <h1>Universities ({ props.universities.total })</h1>

            <div className="admin-universities-page__actions">
                <HanSearch id={'searchQuery'} form={props.form} onChange={props.onFormChange} placeholder={'Find a university'} />

                <HanButton onClick={newUniversity}>Add university</HanButton>
            </div>

            <div className={'admin-universities-page__universities'}>
                <UniversityList
                    universities={props.universities.data}
                    onUniversityClick={onUniversityClick}
                    onUniversityDeleteClick={onUniversityDeleteClick} />
            </div>

            <HanPagination
                pageCount={props.universities.lastPage}
                currentPage={props.universities.currentPage}
                onPageChange={props.onPageChange}
                pageRangeDisplayed={20}/>
        </>
    );
};

export default UniversitiesContent;
